<template>
  <div class="AddressCard">
    <div class="AddressCard__header">
      <div class="AddressCard__title">{{ label }}</div>
      <div v-if="canEdit" class="AddressCard__edit" @click="$emit('editAddress')">Modifier</div>
    </div>
    <div class="AddressCard__infos">
      {{ address.name }}<br />
      {{ address.address }} {{ address.cedex ? 'Cedex' + address.cedex : "" }}<br />
      {{ address.city }}, {{ address.country }} {{ address.zipcode }}<br />
      {{ address.additional_info }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true
    },
    address: {
      type: Object,
      required: true
    },
    canEdit: {
      type: Boolean,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/_variables.scss';

.AddressCard {
  background: $color-smoke;
  padding: 10px;
  font-size: 0.8rem;

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__edit {
    text-decoration: underline;
    cursor: pointer;
  }

  &__title {
    font-weight: 700;
  }
}
</style>
